
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/DashboardSidebar';
import OrderModal from '../components/OrderModal';
import './Dashboard.css';

export default function Dashboard() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderImages, setOrderImages] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('dashboardAuth') !== 'true') {
      navigate('/dashboard/sign-in');
      return;
    }
    fetch('https://orders.fletaime.com/orders-list')
      .then(res => res.json())
      .then(data => {
        setOrders(data.orders || []);
        setLoading(false);
      });
  }, [navigate]);

  const handleRowClick = (order) => {
    navigate(`/dashboard/order/${order.orderNumber}`);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedOrder(null);
    setOrderImages([]);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-content">
        <h2>Orders</h2>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <table className="orders-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Emri</th>
                <th>Produkti</th>
                <th>Data &amp; Ora</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(order => {
                const d = new Date(order.orderDate);
                const formatted = isNaN(d)
                  ? order.orderDate
                  : d.toLocaleString('sq-AL', {
                      day: '2-digit', month: '2-digit', year: 'numeric',
                      hour: '2-digit', minute: '2-digit'
                    });
                return (
                  <tr key={order.orderNumber} style={{cursor:'pointer'}} onClick={() => handleRowClick(order)}>
                    <td>{order.orderNumber}</td>
                    <td>{order.name} {order.lastName}</td>
                    <td>{order.productName}</td>
                    <td>{formatted}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      {/* Modal removed, now opens in new page */}
    </div>
  );
}
